import React, { useState, useRef, useCallback } from "react";
import {
  CircularProgress,
  Backdrop,
  Button,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import CommonHeader from "../components/CommonHeader";
import WebCameraInput from "../components/WebCameraInput";
import checkTodayKey from "../components/CheckTodayKey";
import BaseDialog from "../components/BaseDialog";
import styles from "./ImageGalleryComponentSp.module.css";
import axios from "axios";

// MUIボタンをオーバーラップするためのスタイル
const backBtnStyle = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#c0c0c0",
          color: "#fff",
          fontSize: "0.8rem",
          minWidth: "30vw",
          marginTop: "1rem",
          "&:hover": {
            backgroundColor: "#a9a9a9",
          },
        },
      },
    },
  },
});

const ImageGalleryComponentSp = () => {
  const [imageUrls, setImageUrl] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [pageloaded, setPageloaded] = useState<boolean>(false);
  const [capturingPhoto, setCapturingPhoto] = useState<boolean>(true);
  const captureedImageSrcRef = useRef<string | null>(null);
  const capturingPhotoRef = useRef<boolean>(true);
  const selectedImageReef = useRef<string>("");
  const selectedImageThumbReef = useRef<string>("");
  const isReRender = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLoadingStart = () => {
    setLoading(true);
  };
  const handleLoadingClose = () => {
    setLoading(false);
  };
  const handelChangePhotocapturing = () => {
    setCapturingPhoto(!capturingPhoto);
    setImageUrl([]);
    capturingPhotoRef.current = true;
  };
  // 顔認証撮影の画像をpropsで受け取ってfetchImagesを呼び出す
  const handleCaptureImage = (imageSrc: string, photoCapturing: boolean) => {
    captureedImageSrcRef.current = imageSrc;
    capturingPhotoRef.current = photoCapturing;
    fetchImages();
  };

  // サムネイル一覧を取得する
  const fetchImages = useCallback(() => {
    handleLoadingStart();
    axios
      .post(
        "https://te81dmdu2h.execute-api.ap-northeast-1.amazonaws.com/Prod/facerecognizer",
        {
          process_flug: "recognizer",
          image_s3_path: "",
          jtc_dt_val: "",
          is_photo_upload: "False",
          image_data: captureedImageSrcRef.current,
          boundingBoxInfo: "",
        },
      )
      .then((response) => {
        if (response.data.isMultiFace) {
          alert("複数の顔が検出されました\n一人ずつ撮影してください");
          capturingPhotoRef.current = true;
          return;
        } else if (response.data.matched_file_names.length > 0) {
          setImageUrl(response.data.matched_file_names || []);
        }
      })
      .catch((error) => {
        console.error("Error fetching images:", error);
      })
      .finally(() => {
        handleLoadingClose();
        isReRender.current = true;
      });
  }, [setImageUrl]);

  const openModal = (imageUrl: string) => {
    selectedImageReef.current = imageUrl;
    console.log(selectedImageReef.current);
    const baseUrl =
      "https://poc-lift-iizuna-bucket.s3.amazonaws.com/iizuna/thumbnails/";
    const imageUrlWithoutBase = selectedImageReef.current.startsWith(baseUrl)
      ? imageUrl.slice(baseUrl.length)
      : imageUrl;
    const imageUrlWithoutBaseWithoutQuery = imageUrlWithoutBase.split("?")[0];
    selectedImageThumbReef.current = imageUrlWithoutBaseWithoutQuery;
    setShowModal(true);
  };
  const countUpdl = () => {
    const url =
      "https://rxh8m6izkg.execute-api.ap-northeast-1.amazonaws.com/poc";
    axios
      .post(url, {
        survey_data: {},
        downloaded: "True",
      })
      .then((response) => {
        console.log(
          "uplolad countup data, statusCode:",
          response.data.statusCode,
        );
      });
  };

  const uploadSurvey = (
    ageData: string,
    priceData: string,
    cometoData: string,
    purposeData: string,
    wherefromData: string,
  ) => {
    const url =
      "https://rxh8m6izkg.execute-api.ap-northeast-1.amazonaws.com/poc";
    axios
      .post(url, {
        survey_data: {
          qs1: ageData,
          qs2: priceData,
          qs3: cometoData,
          qs4: purposeData,
          qs5: wherefromData,
        },
        downloaded: "False",
      })
      .then((response) => {
        console.log(
          "upload survey data, statusCode:",
          response.data.statusCode,
        );
      })
      .catch((error) => {
        console.error("Error upload survey data:", error);
      });
  };

  const downloadImage = () => {
    const url =
      "https://rm00dowrkj.execute-api.ap-northeast-1.amazonaws.com/poc/poc-lift-iizuna-bucket/iizuna/contents/" +
      selectedImageThumbReef.current;
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((response) => {
        const blob = new Blob([
          response.data,
          {
            type: response.data.type,
          },
        ]);
        return blob;
      })
      .then((response) => {
        const url = URL.createObjectURL(response);
        const link = document.createElement("a");
        link.href = url;
        const now = new Date();
        now.setHours(now.getHours() + 9);
        const formattedDate = now
          .toISOString()
          .replace(/[-:.]/g, "")
          .replace("T", "")
          .slice(0, 15);
        link.download = `${formattedDate}.jpg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        countUpdl();
      })
      .catch((error) => {
        console.error("Error download image:", error);
      });
  };
  const handleDownloadImage = (imageUrl: string) => {
    downloadImage();
  };
  // 初回レンダリング時、アンケート回答済みでなければアンケート画面に戻る
  React.useEffect(() => {
    if (pageloaded) {
      return;
    }
    if (location.state && location.state.answers.isAnswerd !== null) {
      if (!location.state.answers.isAnswerd) {
        navigate("/");
        return;
      } else if (location.state.answers.isAnswerd) {
        uploadSurvey(
          location.state.answers.ageSl,
          location.state.answers.priceSl,
          location.state.answers.cometoSl,
          location.state.answers.purposeSl,
          location.state.answers.wherefromSl,
        );
      }
    } else {
      navigate("/");
      return;
    }
    checkTodayKey(navigate);
    const handleBack = () => {
      localStorage.setItem("ageSl", location.state.answers.ageSl);
      localStorage.setItem("priceSl", location.state.answers.priceSl);
      localStorage.setItem("cometoSl", location.state.answers.cometoSl);
      localStorage.setItem("purposeSl", location.state.answers.purposeSl);
      localStorage.setItem("wherefromSl", location.state.answers.wherefromSl);
      navigate("/questskiSp", { state: { answers: location.state.answers } });
    };
    window.onpopstate = () => {
      handleBack();
    };
    setPageloaded(true);
  }, [pageloaded, fetchImages, location.state, navigate]);
  document.oncontextmenu = () => {
    return false;
  };
  return (
    <>
      <CommonHeader />
      {capturingPhotoRef.current ? (
        <>
          <p className={styles.explain}>
            撮影済みの画像を検索します
          </p>
          <WebCameraInput handleCaptureImage={handleCaptureImage} />
        </>
      ) : null}
      <main className="p-8">
        <div className={styles.imageGallery}>
          {imageUrls.length > 0
            ? imageUrls.map((url, index) => (
                <div key={index} className={styles.imageItem}>
                  <img
                    src={url}
                    onClick={() => openModal(url)}
                    className={styles.galleryImage}
                    alt=""
                    onError={() => {
                      setImageUrl((prevUrls) =>
                        prevUrls.filter((prevUrl) => prevUrl !== url),
                      );
                    }}
                  />
                </div>
              ))
            : null}
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
            onClick={handleLoadingClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </div>
        <div className={styles.backBtnArea}>
          {imageUrls.length === 0 &&
          isReRender.current &&
          !capturingPhotoRef.current ? (
            <div>
              <div className={styles.backBtnArea}>
                <h3>一致する画像がありませんでした</h3>
              </div>
              <div className={styles.backBtnArea}>
                <ThemeProvider theme={backBtnStyle}>
                  <Button onClick={handelChangePhotocapturing}>再検索</Button>
                </ThemeProvider>
              </div>
            </div>
          ) : isReRender.current && !capturingPhotoRef.current ? (
            <ThemeProvider theme={backBtnStyle}>
              <Button onClick={handelChangePhotocapturing}>再検索</Button>
            </ThemeProvider>
          ) : null}
        </div>
      </main>
      <BaseDialog
        open={showModal}
        imageStr={selectedImageReef.current}
        urlStr=""
        onCancel={() => setShowModal(false)}
        onOk={() => setShowModal(true)}
        handleDownloadImage={handleDownloadImage}
      ></BaseDialog>
    </>
  );
};

export default ImageGalleryComponentSp;
